import { render, staticRenderFns } from "./OutStandingBidsWidget.vue?vue&type=template&id=5c57f7a9&"
import script from "./OutStandingBidsWidget.vue?vue&type=script&lang=js&"
export * from "./OutStandingBidsWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports